import Cookies from 'js-cookie';

const constructURLWithQueryParams = (baseUrl, rfsn, referrer, firstPageVisited) => {
  // Create a URL object to work with the URL string
  const urlObject = new URL(baseUrl);

  // Add 'rfsn' as a query parameter if it exists
  if (rfsn) {
    urlObject.searchParams.set('meta_refersion_id', rfsn);
  }

  // Add 'referrer' as a query parameter if it exists
  if (referrer) {
    urlObject.searchParams.set('meta_source', referrer);
  }

  if (Cookies.get('ps_xid')) {
    urlObject.searchParams.set('meta_partnerstack_xid', Cookies.get('ps_xid'));
  }

  if (Cookies.get('ps_partner_key')) {
    urlObject.searchParams.set('meta_partnerstack_partner_key', Cookies.get('ps_partner_key'));
  }

  if (Cookies.get('utm_source')) {
    urlObject.searchParams.set('meta_utm_source', Cookies.get('utm_source'));
  }

  if (Cookies.get('utm_medium')) {
    urlObject.searchParams.set('meta_utm_medium', Cookies.get('utm_medium'));
  }

  if (Cookies.get('utm_campaign')) {
    urlObject.searchParams.set('meta_utm_campaign', Cookies.get('utm_campaign'));
  }

  // Add 'first_page_visited' as a query parameter if it exists
  if (firstPageVisited || localStorage.getItem('first_page_visited')) {
    urlObject.searchParams.set(
      'meta_first_page_visited',
      firstPageVisited || localStorage.getItem('first_page_visited')
    );
  }

  // Convert the URL object back to a string with the updated query parameters
  const updatedURL = urlObject.toString();

  return updatedURL;
};

export default constructURLWithQueryParams;
